import Progress from '../../../components/progress/Progress';
import { languages } from '../../../data';
import './SkillChart.css';

const SkillChart = () => {
  return (
    <div className="skillChart">
      <div className="my-4 w-full">
        <label>HTML/CSS</label>
        <Progress height="h-1" current={90} barColor="bg-secondary-400" />
      </div>
      <div className="my-4 w-full">
        <label>JavaScript</label>
        <Progress height="h-1" current={80} barColor="bg-secondary-300" />
      </div>
      <div className="my-4 w-full">
        <label>ReactJS</label>
        <Progress height="h-1" current={88} barColor="bg-secondary-400" />
      </div>
      <div className="my-4 w-full">
        <label>Typescript</label>
        <Progress height="h-1" current={84} barColor="bg-secondary-300" />
      </div>
      <div>
        <label>CSS/TailwindCSS/CSS Modules</label>
        <Progress height="h-1" current={90} barColor="bg-secondary-400" />
      </div>
      <div className="my-4 w-full">
        <label>Styled-component/Material-UI</label>
        <Progress height="h-1" current={88} barColor="bg-secondary-300" />
      </div>
      <div className="my-4 w-full">
        <label>Python/Django</label>
        <Progress height="h-1" current={75} barColor="bg-secondary-400" />
      </div>
      <div className="my-4 w-full">
        <label>MySQL/PostgreSQL</label>
        <Progress height="h-1" current={72} barColor="bg-secondary-300" />
      </div>
    </div>
  );
};

export default function SkillTable() {
  return (
    <table className="min-w-full text-primary-200">
      <thead>
        <tr>
          <th className="px-6 py-3 text-secondary-300  text-left  font-semibold  uppercase ">
            Language or Framework
          </th>
          <th className="px-6 py-2  text-secondary-300 text-left text-xs font-semibold  uppercase "></th>
        </tr>
      </thead>
      <tbody className="divide-y divide-primary-600">
        {languages?.map((lang, i) => (
          <tr key={i}>
            <td className="px-6 py-2 whitespace-nowrap text-lg">{lang.lang}</td>
            <td className="px-6 py-2 whitespace-nowrap text-sm">
              {lang.proficiency}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
